import api from './index';


const newsList = async (params) => {
    return api.raw.get('/news/', { params, isAuth: false })
}

const newsDetail = async (id) => {
    return api.raw.get(`/news/${id}/`, { isAuth: false })
}

const newsCreate = async (params) => {
    return api.raw.post(`/news/`, params, { isAuth: true })
}

const newsUpdate = async (id, params) => {
    return api.raw.put(`/news/${id}/`, params, { isAuth: true })
}

const newsDelete = async (id) => {
    return api.raw.delete(`/news/${id}/`, { isAuth: true })
}

export default {
    newsList,
    newsDetail,
    newsCreate,
    newsUpdate,
    newsDelete
}